
  import initWasm from " vite/wasm-helper.js"
  export default opts => initWasm(opts, "__VITE_ASSET__Byy2DG6f__$_?init__")
  